// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import isTouchDevice from "@insite/client-framework/Common/Utilities/isTouchDevice";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
// import { ProductContext } from "@insite/client-framework/Components/ProductContext"; // Starter Custom Code
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import {
    getErrorMessage,
    getProductsForProductInfoList,
} from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import sendImpressionTracking from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/SendImpressionTracking";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
/* Starter Custom Code
import ProductCarouselProduct, {
    ProductCarouselProductStyles,
} from "@insite/content-library/Components/ProductCarouselProduct";
*/
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { injectCss } from "@insite/mobius/utilities";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as cssLinter from "css";
// import useEmblaCarousel from "embla-carousel-react"; // Starter Custom Code
// import React, { createRef, useCallback, useContext, useEffect, useState } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import styled, { css, ThemeProps, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import {
    HasProductContext,
    ProductContext,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import constants from "@store/constants";
import getTextAlignmentField, { textAlignmentOptions } from "@store/Framework/Common/Fields/Toolkit/textAlignment";
import loadProductCarouselCustomProducts from "@store/Framework/Store/Starter/Components/ProductCarousel/Handlers/LoadProductCarouselCustomProducts";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block";
import blockFullWidthField from "@store/Library/Components/Toolkit/Block/fields/fullWidth";
import blockMarginField from "@store/Library/Components/Toolkit/Block/fields/margin";
import blockVariantField from "@store/Library/Components/Toolkit/Block/fields/variant";
import blockVariantSideField from "@store/Library/Components/Toolkit/Block/fields/variantSide";
// import Carousel, { carouselDefaultCustomCss, CarouselPresentationProps } from "@store/Overrides/Components/Carousel"; // Store Custom Code
import ProductCarouselProduct, {
    ProductCarouselProductStyles,
} from "@store/Overrides/Components/ProductCarouselProduct";
import { productCardProps } from "@store/Themes/common/props/productCard";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useIsBreakpoint from "@toolkit/Framework/Common/Hooks/useIsBreakpoint";
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import getMatchingDataFromDictionary from "@toolkit/Framework/Common/Utilities/getMatchingDataFromDictionary";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { SelectProductFieldValue } from "@toolkit/Framework/Types/FieldDefinition";
import React, { createRef, useContext, useEffect, useMemo, useState } from "react";
import loadPurchasedProducts from "@insite/client-framework/Store/Components/PurchasedProducts/Handlers/LoadPurchasedProducts";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";

/* Store Custom Code - Start */
import Carousel, { carouselDefaultCustomCss, CarouselPresentationProps } from "@store/Overrides/Components/Carousel";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const contentZoneName = "Content";
const mobileBreakpoint: BreakpointKey = "xs";

export type ProductCarouselVariantType = (typeof ProductCarouselVariantType)[keyof typeof ProductCarouselVariantType];
export const ProductCarouselVariantType = {
    None: "none",
    ProductDetails: "productDetails",
    AlsoLike: "alsoLike", // Store Custom Code
    Alternative: "alternative",
} as const;

export interface ProductCarouselFields {
    [fields.title]: string;
    [fields.carouselType]: string;
    [fields.displayProductsFrom]: string;
    [fields.selectedCategoryIds]: string[];
    [fields.relatedProductType]: string;
    [fields.numberOfProductsToDisplay]: number;
    [fields.seedWithManuallyAssigned]: string;
    [fields.maxNumberOfColumns]: number;
    [fields.widgetPosition]: number;
    [fields.showImage]: boolean;
    [fields.showTitle]: boolean;
    [fields.showBrandName]: boolean;
    [fields.showPartNumbers]: boolean;
    [fields.showPrice]: boolean;
    [fields.showAddToCart]: boolean;
    [fields.showAddToList]: boolean;
    [fields.showImageBadges]: boolean;
    [fields.maximumNumberOfImageBadges]: number;
    [fields.showTextBadges]: boolean;
    [fields.maximumNumberOfTextBadges]: number;
    [fields.visibleElementsTitle]: string;
    [fields.titleAlignment]: string;
    [fields.customCSS]: string;
    // Starter Custom Code
    [fields.showAvailability]: boolean;
    [fields.showAttributes]: boolean;
    [fields.showDots]: boolean;
    [fields.variant]: ProductCarouselVariant;
    [fields.blockFullWidth]: boolean;
    [fields.blockVariant]: string;
    [fields.blockVariantSide]: string;
    [fields.blockMargin]: string;
    [fields.showContentZone]: boolean;
    [fields.showImageMobile]: boolean;
    [fields.showTitleMobile]: boolean;
    [fields.showBrandNameMobile]: boolean;
    [fields.showPartNumbersMobile]: boolean;
    [fields.showAvailabilityMobile]: boolean;
    [fields.showAttributesMobile]: boolean;
    [fields.showPriceMobile]: boolean;
    [fields.showAddToCartMobile]: boolean;
    [fields.showAddToListMobile]: boolean;
    [fields.showImageBadgesMobile]: boolean;
    [fields.showTextBadgesMobile]: boolean;
    [fields.showDotsMobile]: boolean;
    [fields.peekNextSlide]: boolean;
    [fields.hasMobileSettings]: boolean;
    [fields.customProducts]: [
        {
            fields: {
                [customProductsFields.product]: SelectProductFieldValue;
            };
        },
    ];
    [fields.purchaseType]: string;
}

export type ProductCarouselVariantValue = Partial<Omit<ProductCarouselFields, "variant">>;
export type ProductCarouselVariantOption = DataOption<ProductCarouselVariantValue> & {
    hiddenFields?: (keyof ProductCarouselFields)[];
};

export interface ProductCarouselVariantOptionMapper {
    none: ProductCarouselVariantOption;
    productDetails: ProductCarouselVariantOption;
    alternative: ProductCarouselVariantOption;
}
export type ProductCarouselVariantOptions = DataOptions<ProductCarouselVariantOption> &
    ProductCarouselVariantOptionMapper;
export type ProductCarouselVariant = LiteralUnion<keyof ProductCarouselVariantOptionMapper>;

export const productCarouselVariantOptions: ProductCarouselVariantOptions = {
    none: {
        id: "none",
        displayName: "None",
        isDefault: true,
    },
    productDetails: {
        id: "productDetails",
        displayName: "Product Details",
    },
    /* Store Custom Code - Start */
    AlsoLike: {
        id: "alsoLike",
        displayName: "You might also like",
    },
    /* Store Custom Code - End */
    alternative: {
        id: "alternative",
        displayName: "Alternative",
        value: {
            showAvailability: false,
            showImageBadges: false,
            showTextBadges: false,
            showAddToList: false,
            showAttributes: false,
            showAddToCart: false,
            showBrandName: false,
            showPrice: false,
            maxNumberOfColumns: 6,
            showAvailabilityMobile: false,
            showImageBadgesMobile: false,
            showTextBadgesMobile: false,
            showAddToListMobile: false,
            showAttributesMobile: false,
            showAddToCartMobile: false,
            showBrandNameMobile: false,
            showPriceMobile: false,
        },
    },
};

const isFieldVisibleForVariant = (variant: ProductCarouselVariant, fieldName: keyof ProductCarouselVariantValue) => {
    const { hiddenFields, value } = productCarouselVariantOptions[variant] || {};

    return typeof value?.[fieldName] === "undefined" && !hiddenFields?.includes(fieldName);
};

const AnchorHeading = getWidgetComponent("ProductDetails/ProductDetailsAnchorHeading");
/* Starter Custom Code - End */

const enum fields {
    title = "title",
    carouselType = "carouselType",
    displayProductsFrom = "displayProductsFrom",
    selectedCategoryIds = "selectedCategoryIds",
    relatedProductType = "relatedProductType",
    numberOfProductsToDisplay = "numberOfProductsToDisplay",
    seedWithManuallyAssigned = "seedWithManuallyAssigned",
    maxNumberOfColumns = "maxNumberOfColumns",
    widgetPosition = "widgetPosition",
    showImage = "showImage",
    showTitle = "showTitle",
    showBrandName = "showBrandName",
    showPartNumbers = "showPartNumbers",
    showPrice = "showPrice",
    showAddToCart = "showAddToCart",
    showAddToList = "showAddToList",
    showImageBadges = "showImageBadges",
    maximumNumberOfImageBadges = "maximumNumberOfImageBadges",
    showTextBadges = "showTextBadges",
    maximumNumberOfTextBadges = "maximumNumberOfTextBadges",
    visibleElementsTitle = "visibleElementsTitle",
    titleAlignment = "titleAlignment",
    customCSS = "customCSS",
    // Starter Custom Code
    showAvailability = "showAvailability",
    showAttributes = "showAttributes",
    showDots = "showDots",
    variant = "variant",
    blockFullWidth = "blockFullWidth",
    blockVariant = "blockVariant",
    blockVariantSide = "blockVariantSide",
    blockMargin = "blockMargin",
    showContentZone = "showContentZone",
    customProducts = "customProducts",
    showImageMobile = "showImageMobile",
    showTitleMobile = "showTitleMobile",
    showBrandNameMobile = "showBrandNameMobile",
    showPartNumbersMobile = "showPartNumbersMobile",
    showAvailabilityMobile = "showAvailabilityMobile",
    showAttributesMobile = "showAttributesMobile",
    showPriceMobile = "showPriceMobile",
    showAddToCartMobile = "showAddToCartMobile",
    showAddToListMobile = "showAddToListMobile",
    showImageBadgesMobile = "showImageBadgesMobile",
    showTextBadgesMobile = "showTextBadgesMobile",
    showDotsMobile = "showDotsMobile",
    peekNextSlide = "peekNextSlide",
    hasMobileSettings = "hasMobileSettings",
    purchaseType = "purchaseType",
}

/* Starter Custom Code - Start */
const enum customProductsFields {
    id = "id",
    product = "product",
}
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {
    fields: ProductCarouselFields; // Starter Custom Code
}

/* Starter Custom Code - Start */
const titleAlignmentField = getTextAlignmentField(fields.titleAlignment);
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps & HasProductContext /* Starter Custom Code */) => {
    /* Starter Custom Code - Start */
    const carouselId = `${ownProps.id}-${ownProps.productContext?.product?.id}`;
    const session = getSession(state);
    /* Starter Custom Code - End */

    return {
        products: getProductsForProductInfoList(state, carouselId), // Starter Custom Code
        errorMessage: getErrorMessage(state, carouselId), // Starter Custom Code
        pageType: getCurrentPage(state).type,
        productRecommendationWidgets: state.components.productRecommendations.widgets,
        session: state.context.session,
        // Starter Custom Code
        productInfoByProductId:
            state.components.productInfoLists.productInfoListById[carouselId]?.productInfoByProductId,
        carouselId,
        isAuthenticated: (session.isAuthenticated || session.rememberMe) && !session.isGuest,
    };
};

const mapDispatchToProps = {
    loadCarouselProducts,
    sendImpressionTracking,
    // Starter Custom Code
    loadProductCarouselCustomProducts,
    loadPurchasedProducts,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasShellContext;

export interface ProductCarouselStyles {
    errorMessageText?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    skipCarouselButton?: SkipNavStyles;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    carouselProductStyles?: ProductCarouselProductStyles;
    // Starter Custom Code
    block?: BlockProps;
    carousel?: CarouselPresentationProps;
    prevArrowWrapper?: InjectableCss;
    nextArrowWrapper?: InjectableCss;
    dotsWrapper?: InjectableCss;
    dotButton?: ButtonPresentationProps;
    noResultsFoundText?: TypographyPresentationProps;
    // Store Custom Code
    alsoLikeTitle?: TypographyPresentationProps;
}

export const productCarouselStyles: ProductCarouselStyles = {
    titleText: { variant: "h2" },
    carouselSlideInner: productCardProps.card,
    errorMessageText: { color: "warning" },
    /* Store Custom Code - Start */
    carousel: {
        itemsGap: pxToRem(20),
        extendedStyles: {
            carouselArrowPrevious: {
                extendedStyles: {
                    carouselButton: {
                        size: pxToRemArray([32, null, null, null, 40]),
                    },
                },
            },
            carouselArrowNext: {
                extendedStyles: {
                    carouselButton: {
                        size: pxToRemArray([32, null, null, null, 40]),
                    },
                },
            },
        },
    },
    alsoLikeTitle: {
        variant: "h3",
        forwardAs: "h2",
        css: css`
            font-family: ${x => x.theme.design.typography.fontFamily.title};
            font-weight: ${x => x.theme.design.typography.weight.base};
        `,
    },
    /* Store Custom Code - End */
};

/* Starter Custom Code - Start */
const defaultCustomCss = `.title {
}

${carouselDefaultCustomCss}`;

const mobileTab = {
    displayName: "Mobile",
    sortOrder: 3,
};
/* Starter Custom Code - End */

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 2, // Starter Custom Code
};

const styles = productCarouselStyles;

const ProductCarousel = ({
    id,
    theme,
    fields: baseFields, // Starter Custom Code
    products: baseProducts, // Starter Custom Code
    errorMessage,
    loadCarouselProducts,
    pageType,
    shellContext,
    productRecommendationWidgets,
    sendImpressionTracking,
    session,
    // Starter Custom Code
    carouselId,
    productInfoByProductId,
    loadProductCarouselCustomProducts,
    loadPurchasedProducts,
    isAuthenticated,
}: Props) => {
    const afterCarousel = createRef<HTMLSpanElement>();
    const isProductDetailsPage = pageType === "ProductDetailsPage";
    const isProductListPage = pageType === "ProductListPage";
    const isBrandDetailsPage = pageType === "BrandDetailsPage";
    const brand = useContext(BrandStateContext).value;
    const category = useContext(CategoryContext);
    const productContext = useContext(ProductContext);

    /* Starter Custom Code - Start */
    const fields = useMemo(
        () => overrideProps(baseFields, getDataOptionValue(productCarouselVariantOptions, baseFields.variant)),
        [baseFields],
    );

    const showContentZone = useZoneIsActive(id || "", contentZoneName) && baseFields.showContentZone;
    const [customProductIds, setCustomProductIds] = useState<string[]>([]);

    const products = useMemo(() => {
        if (fields.carouselType === constants.carouselType.customProducts && baseProducts && baseProducts.length > 0) {
            return baseProducts.sort(
                (productA, productB) => customProductIds.indexOf(productA.id) - customProductIds.indexOf(productB.id),
            );
        }
        return baseProducts;
    }, [
        baseProducts,
        fields.carouselType,
        fields.relatedProductType,
        fields.displayProductsFrom,
        fields.selectedCategoryIds,
        fields.numberOfProductsToDisplay,
    ]);

    const title =
        baseFields.title ||
        translate(
            (fields.carouselType === constants.carouselType.purchasedProducts &&
                purchasedTypeOptions.find(o => o.value === fields.purchaseType)?.displayName) ||
                carouselTypeOptions.find(o => o.value === fields.carouselType)?.displayName ||
                "Product Carousel",
        );

    const [canTrackViewItemList, setCanTrackViewItemList] = React.useState(false);
    const productInfos = getMatchingDataFromDictionary(products, productInfoByProductId);

    const trackViewItemList = ga.use.trackViewItemList(
        { items: products, item_list_name: title, item_list_id: fields.carouselType },
        { productInfos },
    );

    ga.use.productInfosCallback(
        productInfos,
        () => {
            setCanTrackViewItemList(false);
            trackViewItemList();
        },
        canTrackViewItemList,
    );
    const isMobile = useIsBreakpoint(mobileBreakpoint, "down");
    const showImage = fields.hasMobileSettings && isMobile ? fields.showImageMobile : fields.showImage;
    const showTitle = fields.hasMobileSettings && isMobile ? fields.showTitleMobile : fields.showTitle;
    const showPrice = fields.hasMobileSettings && isMobile ? fields.showPriceMobile : fields.showPrice;
    const showDots = fields.hasMobileSettings && isMobile ? fields.showDotsMobile : fields.showDots;
    const showBrandName = fields.hasMobileSettings && isMobile ? fields.showBrandNameMobile : fields.showBrandName;
    const showAddToCart = fields.hasMobileSettings && isMobile ? fields.showAddToCartMobile : fields.showAddToCart;
    const showAddToList = fields.hasMobileSettings && isMobile ? fields.showAddToListMobile : fields.showAddToList;
    const showAttributes = fields.hasMobileSettings && isMobile ? fields.showAttributesMobile : fields.showAttributes;
    const showTextBadges = fields.hasMobileSettings && isMobile ? fields.showTextBadgesMobile : fields.showTextBadges;
    const showAvailability =
        fields.hasMobileSettings && isMobile ? fields.showAvailabilityMobile : fields.showAvailability;
    const showImageBadges =
        fields.hasMobileSettings && isMobile ? fields.showImageBadgesMobile : fields.showImageBadges;
    const showPartNumbers =
        fields.hasMobileSettings && isMobile ? fields.showPartNumbersMobile : fields.showPartNumbers;

    useEffect(() => {
        if (fields.carouselType === constants.carouselType.purchasedProducts && isAuthenticated) {
            loadPurchasedProducts({ widgetId: carouselId, purchaseType: fields.purchaseType });
            setCanTrackViewItemList(true);
        }
    }, [fields.carouselType, fields.purchaseType, isAuthenticated, carouselId]);

    useEffect(() => {
        if (fields.carouselType === constants.carouselType.customProducts && fields.customProducts.length > 0) {
            loadProductCarouselCustomProducts({
                numberOfProductsToDisplay: fields.numberOfProductsToDisplay,
                carouselId,
                carouselType: fields.carouselType,
                productIds: fields.customProducts.reduce((productIds, customProduct) => {
                    if (customProduct.fields.product.value) {
                        productIds.push(customProduct.fields.product.value.id);
                    }
                    setCustomProductIds(productIds);
                    return productIds;
                }, [] as string[]),
            });
            setCanTrackViewItemList(true);
        }
    }, [fields.carouselType, fields.numberOfProductsToDisplay, fields.customProducts]);
    /* Starter Custom Code - End */

    useEffect(() => {
        // Starter Custom Code - does not loadCarouselProducts when in shell and editing mode
        if (
            fields.carouselType !== constants.carouselType.customProducts &&
            fields.carouselType !== constants.carouselType.purchasedProducts /* Starter Custom Code */
        ) {
            loadCarouselProducts({
                isShellEdit: shellContext.isInShell && shellContext.isEditing,
                carouselId, // Starter Custom Code
                carouselType: fields.carouselType,
                relatedProductType: fields.relatedProductType,
                seedWithManuallyAssigned: fields.seedWithManuallyAssigned,
                displayProductsFrom: fields.displayProductsFrom,
                selectedCategoryIds: fields.selectedCategoryIds,
                numberOfProductsToDisplay: fields.numberOfProductsToDisplay,
                widgetPosition: fields.widgetPosition,
                isProductDetailsPage,
                productId: productContext?.product?.id,
                isProductListPage,
                category,
                isBrandDetailsPage,
                brand,
            });
            setCanTrackViewItemList(true); // Starter Custom Code
        }
    }, [
        /* Starter Moved -  fields.carouselType - down */
        /* Starter Moved -  fields.relatedProductType - down */
        fields.seedWithManuallyAssigned,
        /* Starter Moved -  fields.displayProductsFrom - down */
        /* Starter Moved -  fields.selectedCategoryIds - down */
        /* Starter Moved -  fields.numberOfProductsToDisplay - down */
        fields.widgetPosition,
        productContext?.product?.id,
        category?.id,
        brand?.id,
        productRecommendationWidgets,
        session?.pickUpWarehouse?.id,
    ]);

    // Starter Removed - Embla implementation

    /* Starter Custom Code - Start */
    // loadCarouselProducts even in shell and editing mode
    useEffect(() => {
        if (
            fields.carouselType !== constants.carouselType.customProducts &&
            fields.carouselType !== constants.carouselType.purchasedProducts
        ) {
            loadCarouselProducts({
                carouselId,
                carouselType: fields.carouselType,
                relatedProductType: fields.relatedProductType,
                seedWithManuallyAssigned: fields.seedWithManuallyAssigned,
                displayProductsFrom: fields.displayProductsFrom,
                selectedCategoryIds: fields.selectedCategoryIds,
                numberOfProductsToDisplay: fields.numberOfProductsToDisplay,
                widgetPosition: fields.widgetPosition,
                isProductDetailsPage,
                productId: productContext?.product?.id,
                isProductListPage,
                category,
                isBrandDetailsPage,
                brand,
            });
            setCanTrackViewItemList(true);
        }
    }, [
        fields.carouselType,
        fields.relatedProductType,
        fields.displayProductsFrom,
        fields.selectedCategoryIds,
        fields.numberOfProductsToDisplay,
    ]);
    /* Starter Custom Code - End */

    useEffect(() => {
        if (
            fields.carouselType !== "recommendedProducts" ||
            !productRecommendationWidgets ||
            fields.widgetPosition > productRecommendationWidgets.length ||
            !products
        ) {
            return;
        }

        const productRecommendationWidget = productRecommendationWidgets[fields.widgetPosition - 1];
        const recommendationIds: number[] = [];
        products?.forEach(o => {
            const id = productRecommendationWidget.recs.find(r => r.refCode === o.productNumber)?.id;
            if (id) {
                recommendationIds.push(id);
            }
        });

        if (recommendationIds.length) {
            sendImpressionTracking({ recommendationIds });
        }
    }, [fields.carouselType, productRecommendationWidgets, products]);

    const getProductRecommendationId = (product: ProductModel) => {
        if (!productRecommendationWidgets || fields.widgetPosition > productRecommendationWidgets.length) {
            return;
        }

        const productRecommendationWidget = productRecommendationWidgets[fields.widgetPosition - 1];
        return productRecommendationWidget.recs.find(r => r.refCode === product.productNumber)?.id;
    };

    if (errorMessage && shellContext.isInShell) {
        return (
            <Typography {...styles.errorMessageText} as="p">
                {`Failed to load carousel products. Error: '${errorMessage}'. Please check widget settings.`}
            </Typography>
        );
    }

    if (
        fields.carouselType === constants.carouselType.purchasedProducts &&
        shellContext.isInShell &&
        shellContext.isEditing
    ) {
        if (!isAuthenticated) {
            return (
                <Typography {...styles.errorMessageText} as="p">
                    {translate("You must be logged in to view the carousel of purchased products.")}
                </Typography>
            );
        }
        if ((!products || products.length === 0) && shellContext.isEditing) {
            return (
                <Typography {...styles.noResultsFoundText} as="p">
                    {translate("No products found")}
                </Typography>
            );
        }
    }

    if (!products || products.length === 0) {
        return null;
    }

    // Starter Moved - title - up
    const showBrandBlocks = showBrandName && products.some(o => !!o.brand); // Starter Custom Code

    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
        `,
    };

    /* Starter Custom Code - Start */
    const variant = fields.variant || ProductCarouselVariantType.None;

    const titleAlignmentCss = css`
        ${cssProp("text-align", fields.titleAlignment)}
    `;

    const titleCss = css`
        ${titleAlignmentCss}
        ${styles.titleText?.css}
    `;

    const titleStyles = variant === ProductCarouselVariantType.AlsoLike ? styles.alsoLikeTitle : styles.titleText; // Store Custom Code

    return (
        <Block
            fullWidth={fields.blockFullWidth}
            variant={fields.blockVariant}
            variantSide={fields.blockVariantSide}
            margin={fields.blockMargin}
            containerCss={customCssWrapper.css}
            {...styles.block}
        >
            {title ? (
                variant === ProductCarouselVariantType.ProductDetails ? (
                    <AnchorHeading
                        fields={{ title }}
                        extendedStyles={{
                            anchorHeading: {
                                title: {
                                    css: titleAlignmentCss,
                                },
                            },
                        }}
                    />
                ) : (
                    <Typography {...titleStyles /* Store Custom Code */} css={titleCss} className="title">
                        {title}
                    </Typography>
                )
            ) : null}
            {showContentZone && <Zone contentId={id} zoneName={contentZoneName} />}
            <Carousel
                {...styles.carousel}
                data-test-selector={`productCarousel_${fields.carouselType}${fields.relatedProductType}`}
                id={`product-carousel-${id}`}
                maxNumberOfColumns={fields.maxNumberOfColumns}
                showDots={showDots}
                peekNextSlide={fields.peekNextSlide} // Starter Custom Code
                slides={products.map(product => ({
                    id: product.id,
                    renderComponent: () => {
                        return (
                            <StyledWrapper
                                {...styles.carouselSlideInner}
                                id={`product_${product.id}`}
                                data-test-key={product.id}
                                data-test-selector="carousel_slide"
                            >
                                <ProductCarouselProduct
                                    carouselId={carouselId} // Starter Custom Code
                                    product={product}
                                    recommendationId={getProductRecommendationId(product)}
                                    showImage={showImage}
                                    showBrand={showBrandBlocks}
                                    showTitle={showTitle}
                                    showPartNumbers={showPartNumbers}
                                    showPrice={showPrice}
                                    showAddToCart={showAddToCart}
                                    showAddToList={showAddToList}
                                    showImageBadges={showImageBadges}
                                    maximumNumberOfImageBadges={fields.maximumNumberOfImageBadges}
                                    showTextBadges={showTextBadges}
                                    maximumNumberOfTextBadges={fields.maximumNumberOfTextBadges}
                                    extendedStyles={styles.carouselProductStyles}
                                    // Starter Custom Code
                                    showAvailability={showAvailability}
                                    showAttributes={showAttributes}
                                />
                            </StyledWrapper>
                        );
                    },
                }))}
            />
        </Block>
    );
    /* Starter Custom Code - End */
};

const carouselTypeOptions = [
    { value: "crossSells", displayName: "Cross Sells" },
    { value: "customersAlsoPurchased", displayName: "Customers Also Purchased" },
    { value: "recentlyViewed", displayName: "Recently Viewed" },
    { value: "relatedProducts", displayName: "Related Products" },
    { value: "topSellers", displayName: "Top Sellers" },
    { value: "recommendedProducts", displayName: "Recommended Products" },
    // Starter Custom Code
    { value: "customProducts", displayName: "Custom Products" },
    { value: "purchasedProducts", displayName: "Purchased Products" },
];

/* Starter Custom Code - Start */
const purchasedTypeOptions = [
    { value: "recently", displayName: "Recently Purchased" },
    { value: "frequently", displayName: "Frequently Purchased" },
];
/* Starter Custom Code - End */

export const ContentWrapper = styled.div<InjectableCss & { alignment: string }>`
    display: flex;
    width: 100%;
    justify-content: ${props => props.alignment ?? "flex-start"};
    ${injectCss};
`;

const widgetModule: WidgetModule<Toolkit.FieldDefinition> /* Starter Custom Code */ = {
    /* Starter Custom Code - Start */
    component: withProductContext(
        connect(mapStateToProps, mapDispatchToProps)(withIsInShell(withTheme(ProductCarousel))),
    ),
    /* Starter Custom Code - End */
    definition: {
        group: "Common",
        icon: "gallery-thumbnails",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            // Starter Removed - fields.titleAlignment
            /* Starter Custom Code - Start */
            {
                ...titleAlignmentField.definition,
                displayName: "Title Alignment",
                defaultValue: textAlignmentOptions.center.id,
                fieldType: "Contextual",
                /* Store Custom Code - Start */
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.titleAlignment);
                },
                /* Store Custom Code - End */
            },
            {
                name: fields.showContentZone,
                displayName: "Show Content Zone",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                /* Store Custom Code - Start */
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.showContentZone);
                },
                /* Store Custom Code - End */
            },
            {
                ...getDataOptionsFieldDefinition(productCarouselVariantOptions),
                name: fields.variant,
                displayName: "Variant",
                editorTemplate: "DropDownField",
                fieldType: "Contextual",
                // Store Custom Code
                sortOrder: 1,
            },
            /* Starter Custom Code - End */
            {
                name: fields.carouselType,
                displayName: "Carousel Type",
                editorTemplate: "DropDownField",
                options: carouselTypeOptions,
                defaultValue: "crossSells",
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
                tab: basicTab,
                customFilter: (item, pageType, settings) => {
                    const {
                        settingsCollection: {
                            websiteSettings: { enableDynamicRecommendations },
                            productSettings: { enableProductRecommendations },
                        },
                    } = settings;

                    if (!enableDynamicRecommendations && item.value === "topSellers") {
                        return false;
                    }
                    /* Starter Custom Code - Start */
                    if (pageType.type === "ProductDetailsPage" && item.value === "customProducts") {
                        return false;
                    }
                    /* Starter Custom Code - End */

                    if (!enableProductRecommendations && item.value === "recommendedProducts") {
                        return false;
                    }

                    if (
                        (pageType.type !== "ProductDetailsPage" && item.value === "relatedProducts") ||
                        (pageType.type !== "ProductDetailsPage" &&
                            pageType.type !== "CartPage" &&
                            item.value === "customersAlsoPurchased")
                    ) {
                        return false;
                    }

                    return true;
                },
            },
            /* Starter Custom Code - Start */
            {
                name: fields.purchaseType,
                displayName: "Purchase Type",
                editorTemplate: "DropDownField",
                options: purchasedTypeOptions,
                defaultValue: "recently",
                fieldType: "General",
                isVisible: item => item.fields[fields.carouselType] === "purchasedProducts",
            },
            {
                name: fields.customProducts,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.product.value ? item.fields.product.value.displayName : translate("Product");
                },
                defaultValue: [],
                fieldType: "Contextual",
                isVisible: item => item.fields[fields.carouselType] === "customProducts",
                fieldDefinitions: [
                    {
                        name: customProductsFields.id,
                        editorTemplate: "UniqueIdField",
                    },
                    {
                        name: customProductsFields.product,
                        displayName: "Product",
                        editorTemplate: "SelectProductField",
                        defaultValue: "",
                    },
                ],
            },
            /* Starter Custom Code - End */
            {
                name: fields.displayProductsFrom,
                displayName: "Display Products From",
                editorTemplate: "DropDownField",
                options: [
                    { value: "allCategories", displayName: "All Categories" },
                    { value: "selectedCategories", displayName: "Selected Categories" },
                    { value: "customerSegments", displayName: "Customer Segments" },
                ],
                defaultValue: "allCategories",
                fieldType: "Contextual",
                isVisible: item => item.fields[fields.carouselType] === "topSellers",
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.selectedCategoryIds,
                displayName: "Selected Categories",
                editorTemplate: "CategoriesField",
                defaultValue: [],
                fieldType: "Contextual",
                isVisible: item =>
                    item.fields[fields.carouselType] === "topSellers" &&
                    item.fields[fields.displayProductsFrom] === "selectedCategories",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.relatedProductType,
                displayName: "Related Product Type",
                editorTemplate: "SystemListDropDownField",
                systemListName: "ProductRelationship",
                defaultValue: "",
                fieldType: "Contextual",
                isVisible: item => item.fields[fields.carouselType] === "relatedProducts",
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.numberOfProductsToDisplay,
                displayName: "Number Of Products To Display",
                editorTemplate: "IntegerField",
                min: 1,
                max: 20,
                defaultValue: 10,
                fieldType: "Contextual",
                isVisible: item =>
                    item.fields[fields.carouselType] === "customersAlsoPurchased" ||
                    item.fields[fields.carouselType] === "topSellers",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.seedWithManuallyAssigned,
                displayName: "Seed With Manually Assigned",
                editorTemplate: "SystemListDropDownField",
                systemListName: "ProductRelationship",
                defaultValue: "",
                fieldType: "Contextual",
                isVisible: (item, _advancedFeaturesEnabled, _theme, pageType) =>
                    pageType === "ProductDetailsPage" && item.fields[fields.carouselType] === "customersAlsoPurchased",
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.maxNumberOfColumns,
                displayName: "Max Number Of Columns",
                editorTemplate: "IntegerField",
                min: 1,
                max: 6, // Starter Custom Code
                defaultValue: 4,
                fieldType: "Contextual",
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.maxNumberOfColumns);
                }, // Starter Custom Code
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.widgetPosition,
                displayName: "Widget Position",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 1,
                fieldType: "Contextual",
                isVisible: item => item.fields[fields.carouselType] === "recommendedProducts",
                /* Starter Removed - sortOrder */
            },
            // Starter Removed - visibleElementsTitle
            {
                name: fields.showImage,
                displayName: "Image",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                /* Starter Removed - isEnabled */
                fieldType: "Contextual",
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.showImage);
                }, // Starter Custom Code
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            /* Starter Custom Code - Start */
            {
                name: fields.peekNextSlide,
                displayName: "Peek Next Slide",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                tab: mobileTab,
                tooltip:
                    "When you select this option, you will see part of the next slide instead of a single full-screen slide on your mobile device.",
            },
            {
                name: fields.hasMobileSettings,
                displayName: "Mobile Specific Settings",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
                variant: "toggle",
                tab: mobileTab,
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.hasMobileSettings);
                },
            },
            {
                name: fields.showImageMobile,
                displayName: "Image",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings } }) => {
                    return hasMobileSettings && isFieldVisibleForVariant(variant, fields.showImageMobile);
                },
            },
            {
                name: fields.showTitleMobile,
                displayName: "Title",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings } }) => {
                    return hasMobileSettings && isFieldVisibleForVariant(variant, fields.showTitleMobile);
                },
            },
            {
                name: fields.showBrandNameMobile,
                displayName: "Brand Name",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings } }) => {
                    return hasMobileSettings && isFieldVisibleForVariant(variant, fields.showBrandNameMobile);
                },
            },
            {
                name: fields.showPartNumbersMobile,
                displayName: "Part Numbers",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings } }) => {
                    return hasMobileSettings && isFieldVisibleForVariant(variant, fields.showPartNumbersMobile);
                },
            },
            {
                name: fields.showAvailabilityMobile,
                displayName: "Show Availability",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings } }) => {
                    return hasMobileSettings && isFieldVisibleForVariant(variant, fields.showAvailabilityMobile);
                },
            },
            {
                name: fields.showAttributesMobile,
                displayName: "Show Attributes",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings, carouselType } }) => {
                    return (
                        hasMobileSettings &&
                        isFieldVisibleForVariant(variant, fields.showAttributesMobile) &&
                        carouselType !== "purchasedProducts"
                    );
                },
            },
            {
                name: fields.showPriceMobile,
                displayName: "Price",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings } }) => {
                    return hasMobileSettings && isFieldVisibleForVariant(variant, fields.showPriceMobile);
                },
            },
            {
                name: fields.showAddToCartMobile,
                displayName: "Add to Cart",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings } }) => {
                    return hasMobileSettings && isFieldVisibleForVariant(variant, fields.showAddToCartMobile);
                },
            },
            {
                name: fields.showAddToListMobile,
                displayName: "Add to List",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings } }) => {
                    return hasMobileSettings && isFieldVisibleForVariant(variant, fields.showAddToListMobile);
                },
            },
            {
                name: fields.showImageBadgesMobile,
                displayName: "Image Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings, carouselType } }) => {
                    return (
                        hasMobileSettings &&
                        isFieldVisibleForVariant(variant, fields.showImageBadgesMobile) &&
                        carouselType !== "purchasedProducts"
                    );
                },
            },
            {
                name: fields.showTextBadgesMobile,
                displayName: "Text Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { variant, hasMobileSettings, carouselType } }) => {
                    return (
                        hasMobileSettings &&
                        isFieldVisibleForVariant(variant, fields.showTextBadgesMobile) &&
                        carouselType !== "purchasedProducts"
                    );
                },
            },
            {
                name: fields.showDotsMobile,
                displayName: "Show Dots",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                tab: mobileTab,
                isVisible: ({ fields: { hasMobileSettings } }) => {
                    return hasMobileSettings;
                },
            },
            /* Starter Custom Code - End */
            {
                name: fields.showTitle,
                displayName: "Title",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                /* Starter Removed - isEnabled */
                fieldType: "Contextual",
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.showTitle);
                }, // Starter Custom Code
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.showBrandName,
                displayName: "Brand Name",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.showBrandName);
                }, // Starter Custom Code
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.showPartNumbers,
                displayName: "Part Numbers",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.showPartNumbers);
                }, // Starter Custom Code
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            /* Starter Custom Code - Start */
            {
                name: fields.showAvailability,
                displayName: "Show Availability",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.showAvailability);
                },
            },
            {
                name: fields.showAttributes,
                displayName: "Show Attributes",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                isVisible: ({ fields: { variant, carouselType } }) => {
                    return (
                        isFieldVisibleForVariant(variant, fields.showAttributes) && carouselType !== "purchasedProducts"
                    );
                },
            },
            /* Starter Custom Code - End */
            {
                name: fields.showPrice,
                displayName: "Price",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.showPrice);
                }, // Starter Custom Code
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.showAddToCart,
                displayName: "Add to Cart",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.showAddToCart);
                }, // Starter Custom Code
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.showAddToList,
                displayName: "Add to List",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                isVisible: ({ fields: { variant } }) => {
                    return isFieldVisibleForVariant(variant, fields.showAddToList);
                }, // Starter Custom Code
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.showImageBadges,
                displayName: "Image Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                isVisible: ({ fields: { variant, carouselType } }) => {
                    return (
                        isFieldVisibleForVariant(variant, fields.showImageBadges) &&
                        carouselType !== "purchasedProducts"
                    );
                }, // Starter Custom Code
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.maximumNumberOfImageBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showImageBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.showTextBadges,
                displayName: "Text Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                isVisible: ({ fields: { variant, carouselType } }) => {
                    return (
                        isFieldVisibleForVariant(variant, fields.showTextBadges) && carouselType !== "purchasedProducts"
                    );
                }, // Starter Custom Code
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            {
                name: fields.maximumNumberOfTextBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showTextBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
                tab: basicTab,
            },
            /* Starter Custom Code - Start */
            {
                name: fields.showDots,
                displayName: "Show Dots",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                tab: basicTab,
            },
            {
                ...blockVariantField,
                name: fields.blockVariant,
                displayName: "Row Variant", // Store Custom Code
                fieldType: "Contextual",
                tab: advancedTab, // Store Custom Code
            },
            {
                ...blockVariantSideField,
                name: fields.blockVariantSide,
                fieldType: "Contextual",
                tab: advancedTab, // Store Custom Code
            },
            {
                ...blockMarginField,
                name: fields.blockMargin,
                fieldType: "Contextual",
                tab: advancedTab, // Store Custom Code
            },
            {
                ...blockFullWidthField,
                name: fields.blockFullWidth,
                fieldType: "Contextual",
                tab: advancedTab, // Store Custom Code
            },
            /* Starter Custom Code - End */
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) =>
                    item.fields[fields.variant] !== ProductCarouselVariantType.ProductDetails &&
                    !!shouldDisplayAdvancedFeatures, // Starter Custom Code
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
